import React, { useState } from 'react';
import { connect } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { isDestroying, ResourcesItem } from 'redux-and-the-rest';

import { IslandModel } from '../../../models/islandModel';
import { destroyIsland } from '../../../redux/reducers/islandReducer';
import { Routes } from '../../../routes';
import AddEditIsland from './AddEditIsland';
import ConfirmDelete from './ConfirmDelete';

import './IslandTile.scss';
import { isEducator } from '../../../utils/UserUtils';
import { UserModel } from '../../../models/userModel';

interface Props {
  island: ResourcesItem<IslandModel>
  onConfirmDelete: (islandId: string) => void;
  onSelectIsland?: (islandId: string) => void;
  user: ResourcesItem<UserModel>
}

const IslandTile = ({
  island, onConfirmDelete, onSelectIsland, user,
}: Props): React.ReactElement | null => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [isDeleteMode, setIsDeleteMode] = useState<boolean>(false);
  const { id, name } = island.values;
  const history = useHistory();

  const handleScoresClick = (studentId: string) => {
    history.push(generatePath(Routes.Account.Student.Show, { id: studentId }));
  };

  const classNames = [
    'island-tile',
    isDestroying(island) ? 'deleting' : undefined,
  ];

  if (isEditMode) {
    return (
      <AddEditIsland
        island={island}
        onCancel={() => setIsEditMode(false)}
        onComplete={() => setIsEditMode(false)}
      />
    );
  }

  const educator = isEducator(user);

  return (
    <div className={classNames.join(' ')}>
      {isDeleteMode || isDestroying(island) ? (
        <ConfirmDelete
          onCancel={() => setIsDeleteMode(false)}
          onConfirm={() => onConfirmDelete(id)}
        />
      ) : (
        <>
          <button
            type="button"
            className="button name"
            onClick={() => {
              if (onSelectIsland) {
                onSelectIsland(id);
              }
            }}
          >
            { name }
          </button>

          <div className="actions">
            {educator && (
              <button
                onClick={() => handleScoresClick(id)}
                type="button"
                className="button"
              >
                Scores
              </button>
            )}

            <button
              onClick={() => setIsEditMode(true)}
              type="button"
              className="button"
            >
              Edit
            </button>

            <button
              onClick={() => setIsDeleteMode(true)}
              type="button"
              className="button"
            >
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = () => ({
  onConfirmDelete: (id: string) => {
    destroyIsland({ id, type: 'islands' });
  },
});

export default connect(mapStateToProps)(IslandTile);
